import {useQuery} from 'react-query';
import {getNotificationCount} from './getNotificationCount';

const useGetNotificationCount = () => {
  const {data, isLoading, refetch} = useQuery<{
    unseen_notifications_count: number;
  }>(['get-notification-count'], getNotificationCount, {
    // Poll every 30 seconds when tab is active
    refetchInterval: 120 * 1000,
    refetchIntervalInBackground: false, // Don't poll when tab is in background

    //  Don't refetch on window focus (avoids flickering)s
    refetchOnWindowFocus: false,

    //  Keep data fresh for 20 seconds before considering it stale
    staleTime: 20 * 1000,

    //  Cache for 10 minutes even after unmounting
    cacheTime: 10 * 60 * 1000,
  });

  const notificationCount = data?.unseen_notifications_count ?? 0;

  return {
    notificationCount,
    isLoading,
    refetch,
  };
};

export default useGetNotificationCount;
